export const LOADING_FORM_PRACTITIONER_REPORT = 'LOADING_FORM_PRACTITIONER_REPORT';
export const ERROR_FORM_PRACTITIONER_REPORT = 'ERROR_FORM_PRACTITIONER_REPORT';
export const RESET_FORM_PRACTITIONER_REPORT = 'RESET_FORM_PRACTITIONER_REPORT';
